"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PreFillBuildsComponent = /*#__PURE__*/function () {
  function PreFillBuildsComponent() {
    _classCallCheck(this, PreFillBuildsComponent);
    this.nameInput = "#frm-createBuildForm-name";
    this.bundleIdInput = "#frm-createBuildForm-bundle_id";
    this.versionInput = "#frm-createBuildForm-version";
    this.sdkInput = "#frm-createBuildForm-id_sdk";
    this.helpUrlInput = "#frm-createBuildForm-help_url";
    this.schemeUrlInput = "#frm-createBuildForm-scheme_url";
    this.solutionFileCopyInput = "#id_solution_file_copy";
    this.downloadSecureUsername = "#frm-createBuildForm-download_username";
    this.optionalSettings = "#frm-createBuildForm-optionalSettings";
    this.devices = "input[name='device_orientation[]']";
    this.targetDevices = "input[name='target_devices[]']";
    this.lists = ".list-wrapper";
    this.initWatchChangeAppName();
    this.initWatchChangeBundle();
    this.initWatchSelectBuild();
    this.initWatchCloseOfferOfBuilds();
  }
  return _createClass(PreFillBuildsComponent, [{
    key: "initWatchSelectBuild",
    value: function initWatchSelectBuild() {
      var _this = this;
      $(document).on("click", ".selectBuild", function () {
        var dataJson = $(this).attr("data-build");
        var data = JSON.parse(dataJson);
        var toFill = [{
          "input": _this.nameInput,
          "value": data.name
        }, {
          "input": _this.bundleIdInput,
          "value": data.bundle_id
        }, {
          "input": _this.versionInput,
          "value": data.version
        }, {
          "input": _this.helpUrlInput,
          "value": data.help_url
        }, {
          "input": _this.schemeUrlInput,
          "value": data.scheme_url
        }, {
          "input": _this.solutionFileCopyInput,
          "value": data.id_solution_file_copy
        }, {
          "input": _this.sdkInput,
          "value": data.sdk
        }, {
          "input": _this.downloadSecureUsername,
          "value": data.download_username
        }, {
          "input": _this.optionalSettings,
          "value": data.download_username
        }, {
          "input": _this.devices,
          "value": data.device_orientation,
          "type": "checklist"
        }, {
          "input": _this.targetDevices,
          "value": data.target_devices,
          "type": "checklist"
        }];
        toFill.forEach(function (val, key) {
          if (val.value !== null || val.value !== "") {
            if (val.type !== undefined && val.type === "checklist") {
              var list = val.value;
              if (list !== null) {
                $.each($(val.input), function (i, e) {
                  var checkboxValue = $(this).val();
                  if (list.includes(checkboxValue)) {
                    $(this).prop("checked", true);
                  } else {
                    $(this).prop("checked", false);
                  }
                });
              }
            } else {
              $(val.input).val(val.value);
            }
          }
        });
        if (data.advancedOptionsRaw !== null) {
          var advancedOptions = JSON.parse(data.advancedOptionsRaw);
          Object.keys(advancedOptions).forEach(function (key) {
            var val = advancedOptions[key];
            var length = $("." + key).length;
            if (length === 1) {
              if ($("." + key).attr("type") === "checkbox") {
                if (Object.prototype.toString.call(val) === '[object Array]') {
                  $.each($("." + key), function (i, e) {
                    var checkboxValue = $(this).val();
                    if (val !== null) {
                      if (val.includes(checkboxValue)) {
                        $(this).prop("checked", true);
                      }
                    }
                  });
                } else {
                  $("." + key).prop("checked", val);
                  console.log(key, val);
                  if (val) {
                    $("." + key).parents("tr").find(".methodValue").removeClass("suppression");
                  } else {
                    $("." + key).parents("tr").find(".methodValue").addClass("suppression");
                  }
                }
              } else {
                $("." + key).val(val);
              }
            } else if (length >= 1) {
              $.each($("." + key), function (i, e) {
                var checkboxValue = $(this).val();
                if (val !== null) {
                  if (val.includes(checkboxValue)) {
                    $(this).prop("checked", true);
                  }
                }
              });
            } else {
              console.log("false", key);
            }
          });
        }
        _this.clearHideAllList();
      });
    }
  }, {
    key: "initWatchCloseOfferOfBuilds",
    value: function initWatchCloseOfferOfBuilds() {
      var _this = this;
      $(document).on("click", this.lists + " i", function () {
        var list = $(this).parents(".list-wrapper");
        _this.clearHideList(list);
      });
    }
  }, {
    key: "initWatchChangeAppName",
    value: function initWatchChangeAppName() {
      var _this = this;
      var timeout;
      var input = _this.nameInput;
      var list = this.getListByInput(input);
      $(input).keyup(function () {
        clearTimeout(timeout);
        var currentInputValue = $(this).val();
        timeout = setTimeout(function () {
          if (currentInputValue !== "") {
            _this.updateListOfItems(list);
          } else {
            _this.clearHideList(list);
          }
        }, 500);
      });
    }
  }, {
    key: "initWatchChangeBundle",
    value: function initWatchChangeBundle() {
      var _this = this;
      var timeout;
      var input = _this.bundleIdInput;
      var list = this.getListByInput(input);
      $(input).keyup(function () {
        clearTimeout(timeout);
        var currentInputValue = $(this).val();
        timeout = setTimeout(function () {
          if (currentInputValue !== "") {
            _this.updateListOfItems(list);
          } else {
            _this.clearHideList(list);
          }
        }, 500);
      });
    }
  }, {
    key: "updateListOfItems",
    value: function updateListOfItems(list) {
      var _this = this;
      var link = list.attr("data-link");
      $.nette.ajax({
        url: link,
        type: 'POST',
        data: {
          name: $(_this.nameInput).val(),
          bundleId: $(_this.bundleIdInput).val()
        },
        complete: function complete(jqXHR, textStatus) {
          if ($("ul li", list).length >= 1) {
            list.show();
          } else {
            list.hide();
          }
        }
      });
    }
  }, {
    key: "clearHideList",
    value: function clearHideList(list) {
      //let items = this.getItemsListElementByList(list);
      //items.empty();
      list.hide();
    }
  }, {
    key: "clearHideAllList",
    value: function clearHideAllList(list) {
      //let items = this.getItemsListElementByList(list);
      //items.empty();
      $(this.lists).hide();
    }
  }, {
    key: "getListByInput",
    value: function getListByInput(input) {
      return $(input).parent().find(".list-wrapper");
    }
  }, {
    key: "getItemsListElementByList",
    value: function getItemsListElementByList(list) {
      return list.find("ul");
    }
  }]);
}();